import { createStyles } from '../../utils';

export const styles = createStyles({
    logo:{
        display:'flex',
        justifyContent: 'center', 
        padding:'20px'
    },
    card: {
        paddingBottom:'20px',
        height: '95%',
    },
    paragraph: {
        paddingTop:'10px',
        color: '#000'
    },
    gridStyle: {
        width: '25%',
        textAlign: 'center',
    }
});